import { environment } from "src/environments/environment";

/**
 * The fan-facing shop.
 *
 * Deliberately NOT going through FetchInterceptor. These endpoints are
 * anonymous, and the interceptor attaches whatever admin token happens to be
 * in storage and bounces to the login screen on a 401 — neither of which a
 * supporter buying a ticket should ever experience. A club employee with the
 * admin site open in another tab must see exactly what any other fan sees.
 */
const anon = async (path: string, init?: RequestInit) =>
	await fetch(`${environment.server.apiURL}/${path}`, {
		...init,
		headers: { "Content-Type": "application/json", ...(init?.headers || {}) }
	});

/** What a club is selling, and for how much. */
export const StorefrontService = {
	get: async (slug: string) => await anon(`Storefront/${encodeURIComponent(slug)}`),
	getFixture: async (slug: string, fixtureId: number) =>
		await anon(`Storefront/${encodeURIComponent(slug)}/Fixture/${fixtureId}`),
	getEvent: async (slug: string, eventId: number) =>
		await anon(`Storefront/${encodeURIComponent(slug)}/Event/${eventId}`),
	getSchedule: async (slug: string, past: boolean) =>
		await anon(`Storefront/${encodeURIComponent(slug)}/Schedule?past=${past}`),
	getHospitality: async (slug: string, fixtureId: number) =>
		await anon(`Storefront/${encodeURIComponent(slug)}/Fixture/${fixtureId}/Hospitality`),
	getMemberships: async (slug: string) =>
		await anon(`Storefront/${encodeURIComponent(slug)}/Memberships`),
	getSeatMap: async (slug: string, fixtureId: number) =>
		await anon(`Storefront/${encodeURIComponent(slug)}/Fixture/${fixtureId}/SeatMap`),
	getBlockSeats: async (slug: string, fixtureId: number, blockId: number) =>
		await anon(`Storefront/${encodeURIComponent(slug)}/Fixture/${fixtureId}/Block/${blockId}`),
	getPaymentConfig: async (slug: string) =>
		await anon(`Storefront/${encodeURIComponent(slug)}/PaymentConfig`)
};

/** Turning a basket into an order and a payment. */
export const CheckoutService = {
	quote: async (data: any) => await anon("Checkout/Quote", { body: JSON.stringify(data), method: "POST" }),
	createOrder: async (data: any) => await anon("Checkout/CreateOrder", { body: JSON.stringify(data), method: "POST" }),
	getOrder: async (orderId: number) => await anon(`Checkout/Order/${orderId}`),
	getTickets: async (orderId: number, key: string) =>
		await anon(`Checkout/Order/${orderId}/Tickets?key=${encodeURIComponent(key)}`)
};
